import React from 'react';
import { useSelector } from 'react-redux';
import types from './types';
import percentToHex from '../PercentToHex';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import Spacer from '../../layout/Spacer';
import { QuizType } from '../../../globals';
import QuizManager from '../../../classes/QuizManager';
import {AppState} from "../../../classes/AppState";

export default function UIRetryButton(props)
{
	let properties = {
		'button text': {
			type: 'text',
			default: 'Try Again'
		},
		'button text color': {
			type: 'color',
			default: '#ffffff'
		},
		'button text alpha': {
			type: 'range',
			default: 80
		},
		'button background color': {
			type: 'color',
			default: '#6B8D9D'
		},
		'button background alpha': {
			type: 'range',
			default: 100
		},
		'visible': {
			type: 'toggle',
			default: true
		}
	}

	if (props.getProperties)
	{
		return properties;
	}

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Try Again Button'}
				subcomponent={types.RETRY_BUTTON}
				properties={properties}
				{...props}
			/>
		)
	}
	else if (props.data.visible)
	{
		const quizSettings = useSelector(store => store.checklistModule.quizSettings);

		const simulation = props.context === 'simulation';
		const data = props.data;
		const okText = data['button text'].value;
		const okColor = data['button text color'].value + percentToHex(data['button text alpha'].value);
		const okBgColor = data['button background color'].value + percentToHex(data['button background alpha'].value);

		if (data['visible'].value !== true) return null;
		if(quizSettings.type !== QuizType.GRADED || !quizSettings.practiceSessions) return null;
		if(!QuizManager.shouldAllowRetry()) return null;

		return (
			<div className={["uiButtonsRow", props.template].join(' ')}
				data-name={'ui-buttons-retry-row-root'}
				data-central={"true"}
			>
				<div className='quizResultsRemainingAttemptsFloatDiv'>
					{QuizManager.GetCurrentNumberOfRetries() > 1 ? QuizManager.GetCurrentNumberOfRetries() + " attempts remaining" : QuizManager.GetCurrentNumberOfRetries() + " attempt remaining"}
				</div>
				<div className={["uiButton", props.template].join(' ')}
					data-name={"ui-button-confirm"}
					style={{
						border: "none",
						backgroundColor: okBgColor,
						fontSize: simulation ? 36 : (30 * props.scale) + "px",
						color: okColor,
						width: "40%",
					}}
					onClick={(e) =>
					{
						const currentNumberOfRetries = QuizManager.GetCurrentNumberOfRetries();
						QuizManager.SetCurrentNumberOfRetries(currentNumberOfRetries - 1);

						// https://scopeardev.slack.com/archives/C02V4RGG2CA/p1664811827039599?thread_ts=1664802292.569479&cid=C02V4RGG2CA
						AppState.restartSimulation(true);
					}}
				>
					{okText}
				</div>
				<Spacer size={{ x: "50%" }} />
			</div>
		);
	}

	return null;
}